import React from 'react';
import { connect, ResolveThunks } from 'react-redux';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { enqueueInfo, NotifierConfirm } from '@paragon/notification-tools';

import { deleteDocument } from '../../actions/documents';
import { jobIsLocked } from '../../modules/jobLocking';
import { getSelectedDocument } from '../../selectors/documents';
import { RootState } from '../../store';

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ResolveThunks<typeof actionCreators>;
type Props = StateProps & DispatchProps;

interface State {
  readonly deleteDocumentOpen: boolean;
}

class DeleteDocument extends React.Component<Props, State> {
  state: State = {
    deleteDocumentOpen: false,
  };

  onDeleteFile = () => {
    if (jobIsLocked()) {
      return;
    }

    this.setState({ deleteDocumentOpen: true });
  };

  onConfirmDelete = () => {
    this.props.onDeleteFile(this.props.selectedDocument.id);
    this.closeDeleteDocument();
  };

  closeDeleteDocument = () => {
    this.setState({ deleteDocumentOpen: false });
  };

  render() {
    return (
      <div>
        <Tooltip disableInteractive disableFocusListener id="delete-tooltip" title="Delete Document">
          <div>
            <IconButton
              sx={{ borderRadius: 0 }}
              disabled={this.props.selectedDocument == null}
              onClick={this.onDeleteFile}
            >
              <DeleteIcon />
            </IconButton>
          </div>
        </Tooltip>
        <NotifierConfirm
          open={this.state.deleteDocumentOpen}
          onClose={this.closeDeleteDocument}
          onClick={this.onConfirmDelete}
          message="Are you sure you want to DELETE this document?"
          buttonText="Delete"
        />
      </div>
    );
  }
}

const mapStateToProps = (state: RootState) => {
  const selectedDocument = getSelectedDocument(state);

  return {
    selectedDocument,
  };
};

const actionCreators = {
  onDeleteFile: deleteDocument,
  enqueueInfo,
};

export default connect(mapStateToProps, actionCreators)(DeleteDocument);
